<template>
  <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" :isImmagini="false" @update="onUpdateJsonData" :isPrestazioni="true" :isAllegati="false">
    <template slot="tab-content-event">
      <visita-gastroenterologica-edit-component :jsonData="jsonData" @update="onUpdateJsonData"></visita-gastroenterologica-edit-component>
    </template>
  </eventi-edit-component>
</template>
<script>
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import VisitaGastroenterologicaEditComponent from "./VisitaGastroenterologicaEditComponent.vue";
export default {
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mixins: [UtilityMixin],
  components: { EventiEditComponent, VisitaGastroenterologicaEditComponent },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    this.jsonData.dataEvento = new Date().getTime();
  },
  data() {
    return {
      linkback: null,
      titoloEvento: this.getLabelTraduora("patients.gastroenterology.gastroenterologicalVisit"),
      pathResource: "/gastrovisitagastroenterologica",
      pathRestValidation: "/validation",
      id: "-1",
      isFirmato: false,
      childKey: 0,
      tabIndex: 0,
      showModalLoading: false,
      jsonData: { dataEvento: null, provenienza: null, referto: "", diagnosi: null, corpoReferto: null, consigliTerapeutici: null, listaOperatori: [] }, //premedicazione: null,strumenti: null
    };
  },
  methods: {
    onFirmaUpdate() {
      let me = this;
      me.loadData();
    },
    onUpdateFile() {
      let me = this;
      me.childKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
  },
};
</script>
